export interface SessionState {
  session: any;
  
}
export interface RootState {
  version: string;
  isLoading: boolean;
  currentRouteName: string;
  importationState : any;
  swreg : ServiceWorkerRegistration
}

export interface Pointage {
  // id_pointage = id du document, affécté à la récupération
  id_pointage: string,
  id_inscription : number,
  id_seance : number | null,
  type : string,
  id_noe_palette : number | null,
  repas1 : boolean | null,
  repas2 : boolean | null,
  arrivee : string | null,
  depart : string | null,
  flag_transfert : number,
}

export interface Inscription {
  id : number,
  id_pac : number,
  id_individu : number,
  debut : string,
  fin : string,
  pe : string,
  type_accueil_pe : string,
  resto : string,
  groupe : string
}

export interface Individu{
  id_individu: number,
  type: string,
  nom: string,
  prenom: string,
  displayName:string,
  date_naissance: string,
  age:number,
  sexe: string,
  photourl : string,
  tel_individu: string,
  tel_famille: string,
  adresse_1: string,
  adresse_2: string,
  cp_ville: string,
  autoris_titre_1: string,
  autoris_texte_1: string,
  autoris_pouce_1: string,
  autoris_titre_2: string,
  autoris_texte_2: string,
  autoris_pouce_2: string,
  autoris_titre_3: string,
  autoris_texte_3: string,
  autoris_pouce_3: string,
  autoris_titre_4: string,
  autoris_texte_4: string,
  autoris_pouce_4: string,
  autoris_titre_5: string,
  autoris_texte_5: string,
  autoris_pouce_5: string,
  autoris_titre_6: string,
  autoris_texte_6: string,
  autoris_pouce_6: string,
  autoris_titre_7: string,
  autoris_texte_7: string,
  autoris_pouce_7: string,
  autoris_titre_8: string,
  autoris_texte_8: string,
  autoris_pouce_8: string,
  classe: string,
  ecole: string,
  instituteur: string,
  ind_groupe_sanguin: string,
  ind_hopital: string,
  ind_no_securite_sociale: string,
  ind_mutuelle: string,
  ind_rubeole: boolean,
  ind_varicelle: boolean,
  ind_angine: boolean,
  ind_rhumatisme: boolean,
  ind_scarlatine: boolean,
  ind_coqueluche: boolean,
  ind_otite: boolean,
  ind_rougeole: boolean,
  ind_oreillons: boolean,
  ind_traitement_medical: boolean,
  ind_texte_traitement_medical: string,
  ind_allergie_alimentaire: boolean,
  ind_allergie_asthme: boolean,
  ind_allergie_medicament: boolean,
  ind_allergie_autre: string,
  ind_texte_allergie: string,
  ind_texte_recommandation: string,
  ind_texte_difficulte_sante: string,
  ind_regime_alimentaire: string,
  ind_remarque_alimentaire: string,
  medecin: Medecin[],
  parents: Parent[],
  id_inscription : number
}
export interface Medecin{
  nom_prenom_medecin: string,
  tel_medecin: string,
  specialite_medecin: string
}
export interface Parent  {
  id_adulte : number,
  id_individu : number,
  nom : string,
  prenom : string,
  tel_domicile : string,
  tel_portable : string,
  tel_bureau : string,
  tel_bureau_poste : string,
  recup : boolean,
}

export interface TempsAccueil{
  id_pac : number,
  tpa_suppl : string,
  id_seance : number,
  date : string,
  heure : string,
  heure_debut : string,
  heure_fin : string,
  nom : string
}

export interface PAC {
  id_pac : number,
  id_eqp : number,
  nom_pac : string,
  module : string,
  debut : Date,
  fin : Date,
  type_pointage : string,
  gest_horaire_fixe : string,
  navette : boolean,
  repas2 : boolean,
  nom_repas2 : string,
  filtre_ecole : string,
  filtre_classe : string,
  filtre_groupe : string,
  filtre_restaurant : string
}

export interface Equipement {
  id_eqp : number,
  equipement : string,
  palettesAn: palettesAn[]
}

export interface palettesAn {
  id_eqp : number,
  tac_id: number,
  action : number,
  code : string,
  nom : string,
  id_noe : number,
  type : string
}

export interface Palette {
  id_pac : number,
  code : string,
  nom : string,
  id_noe : number,
  type : string
}

export interface Trajet {
  id_navette : number,
  code_arret : number,
  nom_circuit : string,
  nom_trajet : string,
  nom_arret : string,
  ordre_arret : number,
}

export interface Navette {
  id_navette : number,
}

export interface ReservationNavette {
  
}

export interface HoraireFixe{
 
}

export const CLOSE_LOADING = "CLOSE_LOADING";
export const SHOW_LOADING = "SHOW_LOADING";
export const SET_LOADING = "SET_LOADING";
export const IS_LOADING = "isLoading";
export const SET_ROUTE_NAME = "SET_ROUTE_NAME";
export const IMPORT_VALUE = "setImportValue"
